import React from 'react';
import { ArrowRight, Heart, Star, ShieldCheck, Mail, Download } from 'lucide-react';
export function CTASection() {
  return <section className="py-10 relative overflow-hidden" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-549">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full blur-[100px] -translate-x-1/3 -translate-y-1/3" style={{
      backgroundColor: 'rgba(109,170,127,0.12)'
    }} data-id="element-550"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full blur-[100px] translate-x-1/3 translate-y-1/3" style={{
      backgroundColor: 'rgba(192,57,43,0.08)'
    }} data-id="element-551"></div>
      <div className="absolute top-1/2 left-1/2 w-[300px] h-[300px] rounded-full blur-[80px] -translate-x-1/2 -translate-y-1/2" style={{
      backgroundColor: 'rgba(47,93,80,0.08)'
    }} data-id="element-552"></div>

      <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl" data-id="element-553">
        <h2 className="text-3xl md:text-5xl font-bold mb-8" style={{
        color: '#2F5D50'
      }} data-id="element-554">
          🐾 ANTES VS. DESPUÉS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10" data-id="element-555">
          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl border shadow-sm" style={{
          borderColor: '#f5c6c2'
        }} data-id="element-556">
            <h3 className="text-xl font-bold mb-6" style={{
            color: '#C0392B'
          }} data-id="element-557">
              ANTES
            </h3>
            <ul className="space-y-4 text-left" data-id="element-558">
              <li className="flex items-center gap-3 text-gray-700" data-id="element-559">
                <span style={{
                color: '#C0392B'
              }} data-id="element-560">
                  ❌
                </span>{' '}
                Alimentación inflamatoria
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-561">
                <span style={{
                color: '#C0392B'
              }} data-id="element-562">
                  ❌
                </span>{' '}
                Malestar constante
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-563">
                <span style={{
                color: '#C0392B'
              }} data-id="element-564">
                  ❌
                </span>{' '}
                Poco ánimo
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-565">
                <span style={{
                color: '#C0392B'
              }} data-id="element-566">
                  ❌
                </span>{' '}
                Riesgos invisibles
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border-2 shadow-lg relative overflow-hidden" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-567">
            <div className="absolute top-0 right-0 w-20 h-20 rounded-full blur-2xl opacity-40 -translate-y-1/2 translate-x-1/2" style={{
            backgroundColor: '#6DAA7F'
          }} data-id="element-568"></div>
            <h3 className="text-xl font-bold mb-6" style={{
            color: '#2F5D50'
          }} data-id="element-569">
              DESPUÉS
            </h3>
            <ul className="space-y-4 text-left" data-id="element-570">
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-571">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-572">
                  ✅
                </span>{' '}
                Menos inflamación
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-573">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-574">
                  ✅
                </span>{' '}
                Mejor digestión
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-575">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-576">
                  ✅
                </span>{' '}
                Más energía
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-577">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-578">
                  ✅
                </span>{' '}
                Mejor calidad de vida
              </li>
            </ul>
          </div>
        </div>

        {/* Guarantee */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border max-w-2xl mx-auto mb-8" style={{
        borderColor: '#6DAA7F',
        backgroundColor: '#FFF3E0'
      }} data-id="element-579">
          <div className="flex flex-col items-center gap-4" data-id="element-580">
            <ShieldCheck className="w-12 h-12" style={{
            color: '#2F5D50'
          }} data-id="element-581" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-582">
              🛡️ GARANTÍA DE 7 DÍAS
            </h3>
            <p className="text-gray-600" data-id="element-583">
              Si no te convence, pides el reembolso dentro de los 7 días y te
              devolvemos toda la plata. Sin enredos. Sin riesgo.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium text-gray-600" data-id="element-584">
          <div className="flex items-center gap-2" data-id="element-585">
            <Mail className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-586" />
            Te llega al correo de una
          </div>
          <div className="flex items-center gap-2" data-id="element-587">
            <Download className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-588" />
            Descarga digital inmediata
          </div>
          <div className="flex items-center gap-2" data-id="element-589">
            <Star className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-590" />
            Fácil de aplicar desde hoy
          </div>
        </div>

        <a href="https://www.tiendasamazonica.com/cart/50863071330589:1" target="_blank" rel="noopener noreferrer" className="block w-full md:w-auto mx-auto mb-12" data-id="element-591">
          <button className="text-white text-xl md:text-2xl font-bold py-6 px-12 rounded-2xl shadow-xl hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-4 w-full group text-center leading-tight mb-8" style={{
          background: 'linear-gradient(to right, #F57C00, #e07000)',
          boxShadow: '0 10px 30px rgba(245,124,0,0.35)'
        }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-592">
            QUIERO SALVAR LA VIDA DE MI MASCOTA AHORA
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform hidden md:block" strokeWidth={3} data-id="element-593" />
          </button>
        </a>

        <div className="bg-white p-8 rounded-2xl shadow-xl border max-w-2xl mx-auto relative" style={{
        borderColor: '#6DAA7F'
      }} data-id="element-594">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-white p-3 rounded-full shadow-lg" style={{
          backgroundColor: '#C0392B'
        }} data-id="element-595">
            <Heart className="w-6 h-6 fill-current" data-id="element-596" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mt-4 mb-2" data-id="element-597">
            🐶 TU PERRO DEPENDE DE TI
          </h3>
          <p className="text-lg text-gray-700 font-medium italic" data-id="element-598">
            "Él no puede pedir ayuda. Tú sí puedes hacer algo hoy."
          </p>
        </div>
      </div>
    </section>;
}